import { prop, round } from './utilities';

export function fbViewItem(product) {
  if (product && Object.keys(product).length !== 0 && window.fbq) {
    window.fbq(
      'track',
      'ViewContent',
      // begin required parameter object
      {
        value: round(prop(product, 'main_good.final_price'), 2),
        currency: prop(product, 'main_good.currency.id') || 'EUR',
        content_type: 'product', // required property
        content_ids: [`${prop(product, 'product_id')}`], // required property, if not using 'contents' property
      },
      // end required parameter object
    );
  }
}

export function fbAddToCart(product) {
  if (product && Object.keys(product).length !== 0 && window.fbq) {
    window.fbq(
      'track',
      'AddToCart',
      // begin required parameter object
      {
        content_name: prop(product, 'product_name') || prop(product, 'name'),
        value: round(prop(product, 'main_good.final_price'), 2),
        currency: prop(product, 'main_good.currency.id') || 'EUR',
        content_type: 'product', // required property
        content_ids: [`${prop(product, 'product_id')}`], // required property, if not using 'contents' property
      },
      // end required parameter object
    );
  }
}

export function fbAddToWishlist(product) {
  if (product && Object.keys(product).length !== 0 && window.fbq) {
    window.fbq(
      'track',
      'fbAddToWishlist',
      // begin required parameter object
      {
        content_name: prop(product, 'product_name') || prop(product, 'name'),
        value: round(prop(product, 'main_good.final_price'), 2),
        currency: prop(product, 'main_good.currency.id') || 'EUR',
        content_type: 'product', // required property
        content_ids: [`${prop(product, 'product_id')}`], // required property, if not using 'contents' property
      },
      // end required parameter object
    );
  }
}

export function fbPurchase(order: any) {
  if (order && Object.keys(order).length !== 0 && window.fbq) {
    const items: any = [];
    const contentIds: any = [];
    if (order.items && order.items.length) {
      order.items.map(item => {
        if (prop(item, 'product_id')) {
          items.push({
            id: prop(item, 'product_id'),
            quantity: prop(item, 'quantity'),
          });
          contentIds.push(`${prop(item, 'product_id')}`);
        }
      });
    }

    window.fbq('track', 'Purchase', {
      value: order.order_tprice,
      currency: prop(order, 'order_tpricecurrency') || 'EUR',
      contents: items,
      content_type: 'product',
      content_ids: contentIds,
    });
  }
}

export function fbInitiateCheckout(cart: any) {
  if (cart && Object.keys(cart).length !== 0 && window.fbq) {
    const items: any = [];
    const contentIds: any = [];
    if (cart.items && cart.items.length) {
      cart.items.map(item => {
        if (prop(item, 'product.product_id')) {
          items.push({
            id: prop(item, 'product.product_id'),
            quantity: prop(item, 'count'),
          });
          contentIds.push(`${prop(item, 'product.product_id')}`);
        }
      });
    }

    window.fbq('track', 'InitiateCheckout', {
      value: cart.total_price,
      currency: prop(cart, 'currency') || 'EUR',
      contents: items,
      content_type: 'product',
      content_ids: contentIds,
    });
  }
}
